import {WebCallService} from "@/utilities/services/WebCallService";
import {PathHelper} from "@/utilities/helpers/PathHelper";
import {ErrorLocationType, HttpType} from "@/utilities/enums/Enums";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import Recipient from "@/models/entities/Recipient";
import GeneralRequest from "@/models/api/GeneralRequest";
import GeneralResponse from "@/models/api/GeneralResponse";

// noinspection DuplicatedCode
export default class RecipientService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    public async getForUser(errorLocationType:ErrorLocationType):Promise<Array<Recipient>|null>{
        const uri = this.uriHelper.recipient.getRecipientForUserPath();
        const requestBody = new GeneralRequest(new Recipient());

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as Array<Recipient>;
    }

    public async getBy(recipientWithSearchProperty:Recipient, propertyNameToSearchBy:string, errorLocationType:ErrorLocationType):Promise<Array<Recipient>|null>{
        const uri = this.uriHelper.recipient.getByPath();
        const requestBody = new GeneralRequest(recipientWithSearchProperty, propertyNameToSearchBy);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as Array<Recipient>;
    }

    public async create(recipient:Recipient, errorLocationType:ErrorLocationType):Promise<Recipient|null>{
        const uri = this.uriHelper.recipient.getCreateRecipientPath();
        const requestBody = new GeneralRequest(recipient);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as Recipient;
    }

    public async update(recipient:Recipient, errorLocationType:ErrorLocationType):Promise<Recipient|null>{
        const uri = this.uriHelper.recipient.getUpdateRecipientPath();
        const requestBody = new GeneralRequest(recipient);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as Recipient;
    }

    public async delete(recipient:Recipient, errorLocationType:ErrorLocationType):Promise<boolean|null>{
        const uri = this.uriHelper.recipient.getDeleteRecipientPath();
        const requestBody = new GeneralRequest(recipient);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.success;
    }

    public async getListAssociations(recipient:Recipient, errorLocationType:ErrorLocationType):Promise<Recipient|null>{
        const uri = this.uriHelper.recipient.getListAssociationsPath();
        const requestBody = new GeneralRequest(recipient);

        const resp = await this.webCaller.httpSend<GeneralResponse>(HttpType.post, uri, requestBody);
        if (resp === null || resp === undefined || !resp.success) {
            await ErrorHandler.handleResponse(resp, errorLocationType);
            return null;
        }

        return resp.data as Recipient;
    }
}